import React from "react";
import "./Header.css";

const logo = `${process.env.PUBLIC_URL}/logo_geocarbon_full.svg`;

const TABS = [
    { id: "about", label: "О проекте" },
    { id: "map", label: "Карта", note: "*бета-версия" },
    { id: "methodology", label: "Методика" },
    { id: "data", label: "Данные" },
];

const Header = ({ activeTab, onChangeTab }) => {
    return (
        <header className="site-header">
            <a
                className="site-logo"
                href="https://geocarbon.ru/"
                target="_blank"
                rel="noopener noreferrer"
                title="Перейти на geocarbon.ru"
            >
                <img className="site-logo-icon" src={logo} alt="Геокарбон" />
            </a>

            <nav className="site-nav">
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        className={`site-nav-item ${
                            activeTab === tab.id ? "active" : ""
                        }`}
                        onClick={() => onChangeTab(tab.id)}
                    >
                        <span className="site-nav-label">
                            {tab.label}
                            {tab.note && (
                                <span className="site-nav-note">
                                    {tab.note}
                                </span>
                            )}
                        </span>
                    </button>
                ))}
            </nav>

            <button
                className="site-cta-button"
                onClick={() => onChangeTab("about")}
            >
                О проекте
            </button>
        </header>
    );
};

export default Header;
